import React from "react";

const NavBar = () => {
    return (
        <header className="w-full border-b border-border bg-surface">
            <div className="max-w-4xl mx-auto px-6 h-14 flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <span className="text-lg font-semibold tracking-tight">SSMLLint</span>
                    <span className="text-sm text-muted font-normal">SSML Validator</span>
                </div>
                <a
                    href="https://github.com/SSMLLint/ssmllint-dot-com"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm text-muted hover:text-accent transition-colors"
                >
                    GitHub
                </a>
            </div>
        </header>
    )
}

export default NavBar
